import { render, staticRenderFns } from "./PostponementCard.vue?vue&type=template&id=7f39a5ce&scoped=true&"
import script from "./PostponementCard.vue?vue&type=script&lang=js&"
export * from "./PostponementCard.vue?vue&type=script&lang=js&"
import style0 from "./PostponementCard.vue?vue&type=style&index=0&id=7f39a5ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f39a5ce",
  null
  
)

export default component.exports